import React, { useState, useEffect } from 'react';
import { assets } from '../assets/assets';

const WhyDonate = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [assets.dog_img1, assets.dog_img2, assets.dog_img1, assets.dog_img2];
  const boxCount = images.length;

  // Function for auto-playing the carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % boxCount);
    }, 3000);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [boxCount]);

  const handleBoxClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div>
      {/* <!-- ======================= about iskas start  ============================ --> */}
      <div className="iskas_foundation pt-5 pb-5 mb-1 mb-sm-5">
        <div className="container">
          <div className="row gy-5 gy-xl-0">
            <div className="col-xl-7">
              <div className="custom_carousel">
                <div className="box-area">
                  {images.map((img, index) => (
                    <div
                      key={index}
                      className={`box ${currentIndex === index ? 'active' : ''}`}
                      onClick={() => handleBoxClick(index)}
                    >
                      <img src={img} className="img-fluid" alt="carousel-img" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-xl-5">
              <div className="about_us">
                <h2 className="title text-primary">Why donate</h2>
                <h3 className="subtitle mb-3">Iskas Foundation</h3>
                <p className="desc mb-2 mb-sm-5 pe-xl-5">
                  By donating to the foundation, you contribute to initiatives focused on education,
                  healthcare, and sustainable development. Your support helps provide quality education to
                  underprivileged children, access to healthcare for vulnerable communities, and promotes
                  environmental conservation.
                </p>
                <ul className="list_style ps-4">
                  <li>We give you photogenic proof with your name and pictures.</li>
                  <li>Timely updates on your donation.</li>
                  <li>100% satisfactory and transparent donation.</li>
                  <li>Get updates on your profile dashboard.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- ======================= about iskas end  ============================ --> */}
    </div>
  );
};

export default WhyDonate;
